<template>
  <!-- <div id="chatWrap" :style="{ top: top + 'px' }" @click="toChat">
    <img src="@/assets/images/chat-1-cn.png" />
  </div>-->
  <div class="quick-navigation">
    <el-backtop :bottom="20" :right="0" v-if="$store.getters.isPC">
      <div
        style="{
          background-color: transparent;
          box-shadow: none;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }"
      >
        <i class="iconfont icon-dingbu" style="font-size: 20px;"></i>
        <span>回到顶部</span>
      </div>
    </el-backtop>
    <div>
      <div class="show-hide-wrap" v-if="!$store.getters.isPC" @click="showHide">
        <div v-if="isShow">
          <i class="iconfont icon-down"></i>
          <span>收起</span>
        </div>
        <div v-if="!isShow">
          <i class="iconfont icon-top"></i>
          <span style="width: 4em; text-align: center;">展开</span>
        </div>
      </div>
      <ul v-if="isShow">
        <li @click="toWechat">
          <i class="iconfont icon-shouji-tianchong"></i>
          <span>小程序</span>
        </li>
        <li v-if="$store.getters.status" @click="toCenter">
          <i class="iconfont icon-gerenzhongxin"></i>
          <span>个人中心</span>
        </li>
        <li @click="toService">
          <i class="iconfont icon-weixiubanshou"></i>
          <span>售后服务</span>
        </li>
        <li @click="toKefu">
          <i class="iconfont icon-kefu"></i>
          <span>人工客服</span>
        </li>
        <li @click="toCart">
          <div class="cart-content">
            <i class="iconfont icon-cart4e"></i>
            <em
              class="shopping-amount"
              v-if="$store.getters.status && $store.getters.cartNum"
            >{{$store.getters.cartNum}}</em>
          </div>
          <span>购物车</span>
        </li>
      </ul>
      <div class="show-hide-wrap" @click="toTop" v-if="!$store.getters.isPC && scrollTop > 100">
        <div>
          <i class="iconfont icon-dingbu" style="font-size: 20px;"></i>
          <span>回到顶部</span>
        </div>
      </div>
    </div>
    <div class="applet" v-if="showCode">
      <img src="../assets/images/code.jpg" />
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request'
import { mapGetters } from 'vuex'
export default {
  name: 'Chat',
  data () {
    return {
      showCode: false,
      isShow: true,
      scrollTop: 0
      // top: (document.documentElement.clientHeight || document.body.clientHeight) - 200
    }
  },
  computed: {
    ...mapGetters(['info'])
  },
  watch: {
    scrollTop (val) {
      if (!this.$store.getters.isPC) {
        if (val > 100) {
          document.getElementById('chatPosition').style.bottom = '147px'
        } else {
          document.getElementById('chatPosition').style.bottom = '95px'
        }
      }
    }
  },
  methods: {
    toWechat() {
      this.showCode = !this.showCode
      if(this.showCode) {
        philips.analytics.trackNavNena({
          navdest: 'WeChat_QRCode',
          navid: "sidebar",
          navtype: "nena"
        })
      }
    },
    toCart () {
      if (this.$store.getters.status) {
        if (this.$route.name != 'cart') {
          philips.analytics.trackNavNena({
            navdest: 'cart',
            navid: "sidebar",
            navtype: "nena"
          })

          this.$router.push('/cart')
        }
      } else {
        let href = '/cart'
        this.$router.replace(`/login?redirectUrl=${href}`)
      }
    },
    toCenter () {
      this.$router.push('/center')
    },
    toKefu () {
      philips.analytics.trackConversion({ 
        name: "chat"
      })

      // let params = ''
      // if (this.info && this.info.id) {
      //   params = '&userid=' + this.info.id
      //   if (this.$route.path == '/product-detail') {
      //     params += '&code=' + this.$route.query.id
      //   }
      // } else if (this.$route.path == '/product-detail') {
      //   params = '&code=' + this.$route.query.id
      // } else {
      //   params = ''
      // }
      // + params
      let NewUrl = 'https://nangua.philips.com.cn/webim/philips.html?appId=99a98db9322c4f4a9742d5218a7ce28b&from_type=11&encrypt=n&lang=zh-CN' // 正式地址
      // let NewUrl = 'https://ocstest.philips.com.cn/livechat/chatapp/customer/branch/philips/PH/iframe.html#mall' + params // 测试地址
      window.open(NewUrl, 'newindow', 'height=607,width=518,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no')
    },
    showHide () {
      this.isShow = !this.isShow
      this.showCode = false
      try {
        if (this.isShow) {
          document.querySelector('#chatPosition').style.display = 'block'
        } else {
          document.querySelector('#chatPosition').style.display = 'none'
        }
      } catch (error) {}
    },
    toTop () {
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = this.scrollTop -= 50
        if (this.scrollTop <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    handerScroll (e) {
      if (e.target.documentElement || e.target.body) {
        this.scrollTop =
          e.target.documentElement.scrollTop || e.target.body.scrollTop // 滚动高度
        // let clientHeight = document.documentElement.clientHeight || document.body.clientHeight // 屏幕高度
        // this.top = scrollTop + clientHeight - 200
      }
    },
    toChat () {
      let href =
        'https://ph-china.livecom.cn/5g/ch/?=&aid=9l9dZQtFIAA%3D&gid=4&agent=0&skill=undefined&tag=Philips%20Flagship%20Webshop&cat=&chan=LWC;LVC;LVI&fields=&sID=7yWk8fS9DQM%3D&cID=8vQZlHx4qgE%3D&lcId=Homepage&url=https%3A%2F%2Fwww.shop.philips.com.cn%2F&ref=https%3A%2F%2Fwww.shop.philips.com.cn%2F'
      window.open(href, 'newwindow', 'height=400, width=500, top=100')
    },
    toService () {
      philips.analytics.trackNavNena({
        navdest: 'sale-after',
        navid: "sidebar",
        navtype: "nena"
      })

      this.$router.push(`/sale-after?id=changeRole`)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handerScroll, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handerScroll)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/mixin';
#chatWrap {
  position: absolute;
  z-index: 9;
  right: 5vw;
  top: 90vh;
  transition: top 1s;
  cursor: pointer;
  img {
    display: block;
    width: 15vw;
    max-width: 80px;
  }
}
.quick-navigation {
  position: fixed;
  right: 0;
  bottom: 100px;
  background: #fff;
  z-index: 9;
  border: 1px solid #f5f5f5;
  ul {
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      padding: 20px 10px;
      color: #757575;
      font-size: 12px;
      cursor: pointer;
      i {
        font-size: 22px;
        margin-bottom: 5px;
      }
      .cart-content {
        position: relative;
        .shopping-amount {
          position: absolute;
          top: -4px;
          right: -6px;
          padding: 1px;
          font-size: 12px;
          line-height: 14px;
          color: #fff;
          background-color: #f10215;
          border-radius: 50% 50% 50% 0;
          min-width: 14px;
          text-align: center;
        }
      }
    }
    li:hover {
      color: $blue;
    }
    li:last-child {
      border-bottom: 0;
    }
  }
  .show-hide-wrap {
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 10px;
      color: #757575;
      font-size: 12px;
      cursor: pointer;
      border-bottom: 1px solid #f5f5f5;
      i {
        font-size: 18px;
        margin-bottom: 5px;
      }
    }
  }
  .applet {
    position: absolute;
    top: 0;
    right: 70px;
    width: 200px;
    img {
      width: 100%;
      display: block;
    }
  }
}
@media screen and (max-width: 1366px) {
  .quick-navigation {
    bottom: 73px;
    .el-backtop {
      width: 58px !important;
      height: 62px !important;
      bottom: 10px !important;
    }
    ul {
      li {
        padding: 8px 5px;
        i {
          font-size: 14px;
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .quick-navigation {
    position: fixed;
    right: 0;
    bottom: 50px;
    background: #fff;
    z-index: 9;
    border: 1px solid #f5f5f5;
    ul {
      li {
        padding: 6px 3px;
        i {
          margin-bottom: 0;
        }
      }
    }
    .show-hide-wrap {
      > div {
        padding: 6px 3px;
        i {
          margin-bottom: 0;
        }
      }
    }
    .applet {
      right: 55px;
      width: 200px;
    }
  }
}
</style>
<style lang="scss">
@import '../assets/css/mixin';
.el-backtop {
  width: 68px !important;
  height: 80px !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: 1px solid #f5f5f5 !important;
  color: #757575 !important;
}
.el-backtop:hover {
  background-color: #fff !important;
  color: $blue !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Chat.vue